import { CSSProperties } from 'react';

import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

const StyledDashDivider = styled.div<DashDividerProps>`
  margin: 10px 0;
  border-bottom: 1px dashed ${(props) => props.color || colors.gray200};
`;

interface DashDividerProps {
  color?: string;
  sx?: CSSProperties;
}

export const DashDivider = (props: DashDividerProps) => {
  return <StyledDashDivider color={props.color} style={props.sx} />;
};
